import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postPurchaseOrder({ body }) {
  return BaseService.post(REST.PURCHASE_ORDERS, body);
}

function postPurchaseOrderArrival({ body }) {
  return BaseService.post(REST.PURCHASE_ORDERS_ARRIVAL, body);
}

function putPurchaseOrder({ body, id }) {
  return BaseService.put(REST.PURCHASE_ORDERS_ID(id), body);
}

function putPurchaseOrderApprovals({ body, id }) {
  return BaseService.put(REST.PURCHASE_ORDERS_APPROVAL_ID(id), body);
}

function putPurchaseOrderArrival({ body, id }) {
  return BaseService.put(REST.PURCHASE_ORDERS_ARRIVAL_ID(id), body);
}

function getPurchaseOrdersApprovals(params) {
  return BaseService.get(REST.PURCHASE_ORDERS_APPROVAL, {
    params: paramsFilter({ params }),
  });
}

function getPurchaseOrders(params) {
  return BaseService.get(REST.PURCHASE_ORDERS, {
    params: paramsFilter({ params }),
  });
}

function getPurchaseOrderItems(params) {
  return BaseService.get(REST.PURCHASE_ORDERS_ITEMS, {
    params: paramsFilter({ params }),
  });
}

function deletePurchaseOrder({ id }) {
  return BaseService.delete(REST.PURCHASE_ORDERS_ID(id));
}

export default {
  getPurchaseOrders,
  getPurchaseOrdersApprovals,
  getPurchaseOrderItems,
  putPurchaseOrder,
  putPurchaseOrderApprovals,
  putPurchaseOrderArrival,
  postPurchaseOrder,
  postPurchaseOrderArrival,
  deletePurchaseOrder,
};
